module.exports = __webpack_public_path__ + "static/img/t3-1.d955086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t3-1.png
// module id = yih3
// module chunks = 1